const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        // marginTop: "25px"
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        paddingTop: "30px",
        paddingBottom: "20px",
    },
    inputContainer: {
        marginTop: "20px",
    },
    avatarContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        marginTop: theme.spacing(2)
    },
    avatar: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.primary.main
    },
    avatarActions: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    buttonContainer: {
        marginTop: "20px",
        marginBottom: "20px",
    },
});

export default styles;
